module.exports = __webpack_public_path__ + "img/logo.3515ead4.png";